import { css } from 'styled-components';
import { ArrowIcon } from '../../../images/icons/arrow';
import { colors, screensInt } from '../../../styles/constants';
import { Icon24 } from '../../Icon';
import {
  PanelCloseButton,
  PanelContainer,
  PanelContent,
  PanelHeader,
  PanelTitle,
} from './common';
import { PanelProps } from './types';

const ArrowIconStyle = css`
  ${Icon24}
  transform: rotateY(180deg);
`;

const SecondaryPanel: React.FC<PanelProps> = ({
  children,
  closeButtonRef,
  onClose,
  testid,
  title,
}) => {
  return (
    <PanelContainer data-testid={testid} desktopBreakpoint={screensInt.md}>
      <PanelHeader>
        <PanelCloseButton
          ref={closeButtonRef}
          onClick={(event) => onClose(event)}
          type="button"
        >
          <ArrowIcon color={colors.text} customStyle={ArrowIconStyle} />
        </PanelCloseButton>
        <PanelTitle>{title}</PanelTitle>
      </PanelHeader>

      <PanelContent>{children}</PanelContent>
    </PanelContainer>
  );
};

export default SecondaryPanel;
